 
import JobBreadcrumb from "../../commonComponents/breadcrumbs/JobBreadcrumb";
import JobDetail from "../../commonComponents/productDetail/JobDetail";

const JobDetail5Container = () => {
  return (
    <>
      <JobBreadcrumb type="style_4" />
      <JobDetail detailType="style_5" />
    </>
  );
};

export default JobDetail5Container;
